import styled from '@emotion/styled';

import { createClassNames } from '@hrworks/design-system/functions';
import { resetListStyles } from '@hrworks/design-system/utilities';

import { Section as _Section, SectionStyles } from '../../Section';
import { TitleStyles } from '../../Title';

const SectionContainer = styled.li(({ theme }) => ({
  marginTop: `calc(${theme.eclipseTier1.spacing['16px']} * 2)`,
  ':first-of-type': {
    marginTop: theme.eclipseTier1.spacing['12px'],
  },
}));

const Section = styled(_Section)(({ theme }) => ({
  [`${SectionStyles.sel.ChildrenContainer}`]: {
    margin: 0,
    marginTop: theme.eclipseTier1.spacing['8px'], // Distance between SectionTitle and SectionChildren
  },
  [`${TitleStyles.sel.TitleContainer}`]: {
    ...theme.eclipseTier2Typography.navHeader,
    color: theme.eclipseTier2Color.text.brand.default,
    paddingLeft: theme.eclipseTier1.spacing['12px'],
  },
}));

const SectionChildren = styled.ul([resetListStyles]);

const components = { SectionContainer, Section, SectionChildren };
const { cls, sel } = createClassNames('CollapsibleMenuSection', components);

export const S = {
  ...components,
  cls,
  sel,
} as const;
